/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Createyourfirstlistingtoshowcaseyourbusiness7Inputs */

const en_createyourfirstlistingtoshowcaseyourbusiness7 = /** @type {(inputs: Createyourfirstlistingtoshowcaseyourbusiness7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create your first listing to showcase your business`)
};

const de_createyourfirstlistingtoshowcaseyourbusiness7 = /** @type {(inputs: Createyourfirstlistingtoshowcaseyourbusiness7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstell deinen ersten Ort, um dein Unternehmen zu zeigen.`)
};

/**
* | output |
* | --- |
* | "Create your first listing to showcase your business" |
*
* @param {Createyourfirstlistingtoshowcaseyourbusiness7Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const createyourfirstlistingtoshowcaseyourbusiness7 = /** @type {((inputs?: Createyourfirstlistingtoshowcaseyourbusiness7Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Createyourfirstlistingtoshowcaseyourbusiness7Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_createyourfirstlistingtoshowcaseyourbusiness7(inputs)
	return de_createyourfirstlistingtoshowcaseyourbusiness7(inputs)
});
export { createyourfirstlistingtoshowcaseyourbusiness7 as "createYourFirstListingToShowcaseYourBusiness" }